<template>
    <div class="intent-editor">
        <div class="intent-editor__left">
            <intent-type
                :type="localIntent.type"
                :readonly="$props.isIntentEditing"
                @type-changed="onTypeChange"
            />
        </div>
        <div class="intent-editor__center">
            <text-intent
                v-if="localIntent.type === 'TEXT'"
                :intent.sync="localIntent.name"
                :readonly="!$props.isIntentEditing"
                :errors="errors.textIntent"
            />
            <json-intent
                v-if="localIntent.type === 'JSON'"
                :intent.sync="localIntent.name"
                :readonly="!$props.isIntentEditing"
                :errors="errors.jsonIntent"
            />
            <flow-intent
                v-if="localIntent.type === 'FLOW'"
                :intent.sync="flowIntentParams"
                :readonly="!$props.isIntentEditing"
                :errors="errors.flowIntent"
            />
        </div>
        <div class="intent-editor__right">
            <div
                v-if="$props.isIntentEditing && !$props.isNewIntent"
                class="buttons-wrap"
            >
                <or-icon-button
                    icon="close"
                    size="small"
                    class="flat"
                    type="secondary"
                    @click.stop="$emit('reset')"
                />
                <or-icon-button
                    icon="done"
                    size="small"
                    class="flat"
                    type="secondary"
                    @click.stop="saveIntent"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { isValidJSON } from '@/utils/validations'
import intentType from './intent_type'
import textIntent from './types/text_intent'
import jsonIntent from './types/json_intent'
import flowIntent from './types/flow_intent'

export default {
  components: {
    intentType,
    textIntent,
    jsonIntent,
    flowIntent
  },

  props: {
    isNewIntent: Boolean,
    isIntentEditing: Boolean,
    intent: Object,
    flowEntityUpdating: Boolean,
    errors: {
      textIntent: Object,
      jsonIntent: Object,
      flowIntent: Object,
      isValid: Boolean
    }
  },

  computed: {
    localIntent: {
      get () {
        return this.intent
      },
      set (value) {
        this.$emit('update:intent', value)
      }
    },

    flowIntentParams: {
      get () {
        return isValidJSON(this.localIntent.name)
          ? JSON.parse(this.localIntent.name)
          : this.defaultFlowParams
      },
      set (value) {
        this.localIntent.name = JSON.stringify(value)
      }
    }
  },

  data () {
    return {
      defaultFlowParams: {
        label: '',
        name: '',
        paramsType: {},
        params: {}
      },
      defaultJsonIntent: {},
      isConfPhraseModalOpened: false,
      isConfPhraseUpdating: false
    }
  },

  methods: {
    saveIntent () {
      this.$emit('save')
    },

    onTypeChange (type) {
      if (this.localIntent.type === type) {
        return
      }

      this.localIntent.type = type

      if (type === 'TEXT') {
        this.localIntent.name = ''
      }
      if (type === 'JSON') {
        this.localIntent.name = JSON.stringify(this.defaultJsonIntent)
      }
      if (type === 'FLOW') {
        this.flowIntentParams = this.defaultFlowParams
      }
    },

    resetValidation () {
      console.log('reset validation')

      console.log('$v: ', this.$v)
    }
  }
}
</script>

<style lang="scss" scoped>
    .intent-editor {
        display: flex;
        flex-grow: 1;

        &__left {
            min-width: 60px;
            padding: $sp-2;
        }

        &__center {
            display: flex;
            flex-grow: 1;
            padding: $sp-2;

            .ui-textbox {
                margin: 0;
            }
        }

        &__right {
            display: flex;
            justify-content: flex-end;

            .buttons-wrap {
                display: flex;
            }
        }
    }
</style>
